import { render, staticRenderFns } from "./PointsExchangeRedeemPage.vue?vue&type=template&id=5f74c685&scoped=true"
import script from "./PointsExchangeRedeemPage.vue?vue&type=script&lang=js"
export * from "./PointsExchangeRedeemPage.vue?vue&type=script&lang=js"
import style0 from "./PointsExchangeRedeemPage.vue?vue&type=style&index=0&id=5f74c685&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f74c685",
  null
  
)

export default component.exports